import QueuePage from './QueuePage'

export default QueuePage
